import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfirm } from 'material-ui-confirm';
import { Room, User } from '../types';
import { AcsService } from '../services';

export function useAcceptParticipantCallback(
  room: Room | undefined,
  participant: User
) {
  const { t } = useTranslation();
  const confirm = useConfirm();

  return useCallback(() => {
    if (!room) {
      return;
    }

    confirm({
      title: t('room.accept.title'),
      description: t('room.accept.description', {
        name: participant.properties.name,
      }),
      confirmationText: t('common.yes'),
      cancellationText: t('common.no'),
    })
      .then(() =>
        AcsService.acceptParticipant(
          room!.id,
          participant.properties.acsUserId
        ).catch(console.error)
      )
      .catch(() => {
        // Just ignore cancellation
      });
  }, [
    confirm,
    participant.properties.acsUserId,
    participant.properties.name,
    room,
    t,
  ]);
}
